import Vue from 'vue'
import Vuex from 'vuex'

import customer from './customer';
import product from './product';
import item from './item';

Vue.use(Vuex)

const CHECK_INTERVAL = 5 * 60 * 1000;       // 5 Minutes in milliseconds

export default new Vuex.Store({
  state: {
    error: {},
    user: null,
    companies: [],
    companyId: null,
    version: localStorage.getItem('version'),
    oldVersion: '',
    newVersion: false,
    setupReminder: false,
    drawer: true,
    taskCount: 0,
    appsAlert: false,
    _lastCheck: 0,
    help: {},
    showHelp: false,
    disableSearchHotKey: false,
    globalDate: false,
    globalDateRange: [null, null]
  },
  getters: {
    company: state => state.companies.find(company => company.id === state.companyId),
    userSettings : state => {
      const company = state.companies.find(company => company.id === state.companyId);
      return JSON.parse(company?.userSettings);
    },
    doneSetup: state => {
      const company = state.companies.find(company => company.id === state.companyId);
      return company.settings.doneSetup;
    },
    sites: state => (active, excise) => state.companies.find(company => company.id === state.companyId)?.
     sites.filter(site => (!active || site.active) &&
                        ((!excise?.B262 && !excise?.B263 && !excise?.B265 && !excise?.B266) || excise?.B262 && site.B262 || excise?.B263 && site.B263 || excise?.B265 && site.B265 || excise?.B266 && site.B266)
                  ) ?? []
  },
  mutations: {
    _setLastChecked(state) {
      state._lastCheck = Date.now();
    },
    async setUserSettings(state, settings) {
      const company = state.companies.find(company => company.id === state.companyId);
      company.userSettings = JSON.stringify(settings);
      await Vue.prototype.$apiCall(`mutation store($settings:String!) {
        companySetUserSettings(settings:$settings) {id}
      }`,
      {settings:company.userSettings});
    },
    setSetupReminder(state) {
      state.setupReminder = true;
    },
    setError(state, error) {
      state.error = error;
    },
    clearUser(state) {
      state.user = null;
    },
    setUser(state, user) {
      state.user = user;
    },
    setDrawer(state, drawer) {
      state.drawer = drawer;
    },
    setCompanies(state, companies) {
      state.companies = companies;
      if (!state.companyId)
        state.companyId = localStorage.getItem('companyId');
      if (state.companyId && companies.find(company => company.id === state.companyId) == undefined)
        state.companyId = null;
      if (!state.companyId && companies.length > 0) {
        state.companyId = companies[0].id;
        localStorage.setItem('companyId', state.companyId);
      }
      if (state.companyId)
        document.title = `PŪRTRAK - ${state.companies.find(company => company.id === state.companyId).name}`;
    },
    setCompanyId(state, companyId) {
      state.companyId = companyId;
      localStorage.setItem('companyId', companyId);
      document.title = `PŪRTRAK - ${state.companies.find(company => company.id === companyId).name}`;
    },
    clearCompanyId(state) {
      delete state.companyId;
      localStorage.removeItem('companyId');
      document.title = `PŪRTRAK`;
    },
    setVersion(state, version) {
      if (state.version && state.version !== version) {
        state.newVersion = true;
        state.oldVersion = state.version;
      }
      state.version = version;
      localStorage.setItem('version', version);
    },
    setTaskCount(state, taskCount) {
      state.taskCount = taskCount;
    },
    setAppsAlert(state, on) {
      state.appsAlert = on;
    },
    setHelp(state, help) {
      state.help = help;
    },
    setShowHelp(state, showHelp) {
      state.showHelp = showHelp;
    },
    setDisableSearchHotKey(state, disableSearchHotKey) {
      state.disableSearchHotKey = disableSearchHotKey;
    },
    setGlobalDate(state, globalDate) {
      state.globalDate = globalDate;
    },
    setGlobalDateRange(state, globalDateRange) {
      state.globalDateRange = globalDateRange;
    }
  },
  actions: {
    help({commit}, help) {
      commit('setHelp', help);
      commit('setShowHelp', true);
    },
    async refreshCompanies({commit}) {
      const results = await Vue.prototype.$apiCall(`query XXXstore {
                                                      companies {
                                                        id,name,fiscalYearMonth,
                                                        settings {doneSetup,dateFormat,timeFormat,timeZone,multiCurrency,homeCurrency,
                                                                  trackLitres,trackKg,trackStrength,useAccounts,
                                                                  exciseAccrual,exciseCreateReceipt,excisePaymentToId,excisePaymentMethodId,exicsePaymentAccountRef,excisePaymentItemId,
                                                                  lotTrackingForProducts,lotTrackingForDutyPaid},
                                                        qboPlan,
                                                        addOns,permissions,connectedToAccounting,userSettings, status,v8,paymentPeriodEnd,excisePeriodEnd,province,
                                                        maxUsers,allowMultipleSites,allowAccounting,allowPO,allowCSVExport,allowWine,allowApprovedFormulation,
                                                        allowAudit,allowPlanning,allowRecurringTransactions,
                                                        sites {id,name,active,B262,B263,B265,B266,spiritsLicense,userLicense,wineLicense,warehouseLicense,preferred,shippingAddress}
                                                      }
                                                    }`,
                                                    {});
      if (!results.error)
        commit('setCompanies', results.data.companies);
      return results.error;
    },
    async checkTasks({state, commit, getters}, immediate=false) {
      if (!immediate)
        if (state._lastCheck > Date.now() - CHECK_INTERVAL)   // Only check occassionally
          return;

      const results = await Vue.prototype.$apiCall(`query store($planning: Boolean!) {
                                                      activitiesOutstandingForUser @include(if:$planning)
                                                      addOnsWithAlerts
                                                    }`,
                                                  {planning:getters.company.allowPlanning});
      if (!results.error) {
        if (getters.company.allowPlanning)
          commit('setTaskCount', results.data.activitiesOutstandingForUser);
        commit('setAppsAlert', !!results.data.addOnsWithAlerts.length)
      }

      commit('_setLastChecked');
    }
  },
  modules: {
    customer, product, item
  }
})
